import React from "react"
import { Box, Button, HStack, Text } from "@chakra-ui/react"
import { PlusIcon, CheckIcon } from "@heroicons/react/24/outline"
import { c } from "../classroomColors"

// Muted semantic dot colors that read on both light and dark surfaces.
const DOT = {
  easy: "#34d399",
  medium: "#f0b93a",
  hard: "#f87171",
}

export function DifficultyPill({ level, label, isSelected, onClick }) {
  const dot = DOT[level] || DOT.medium

  return (
    <Button
      variant="unstyled"
      onClick={onClick}
      display="inline-flex"
      padding="8px 14px"
      height="auto"
      justifyContent="center"
      alignItems="center"
      borderRadius="24px"
      fontSize="12px"
      fontWeight={500}
      lineHeight="normal"
      border="1px solid"
      borderColor={isSelected ? dot : c.border}
      background={c.surfaceSubtle}
      color={c.text}
      boxShadow={isSelected ? `inset 0 0 0 1px ${dot}` : "none"}
      _hover={{
        background: c.hover,
        borderColor: dot,
      }}
    >
      <HStack spacing="6px">
        <Box boxSize="7px" borderRadius="full" background={dot} />
        <Text>{label}</Text>
        {isSelected ? (
          <CheckIcon width={13} height={13} style={{ color: dot }} />
        ) : (
          <PlusIcon width={13} height={13} style={{ opacity: 0.55 }} />
        )}
      </HStack>
    </Button>
  )
}
